/**
 * Vulnerabilities section GetStarted method configurations
 *
 * Defines the available methods for getting started with vulnerability discovery:
 * 1. Seeds - Discover vulnerabilities by scanning defined targets
 * 2. Integrations - Connect vulnerability scanners (Nessus, Qualys, etc.)
 * 3. Import - Upload vulnerability data from external tools
 */

import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import {
  Integrations as IntegrationsIcon,
  Seeds as SeedsIcon,
} from '@praetorian-chariot/ui';

import type { GetStartedMethod } from '@/components/modals/GetStartedModal';

/**
 * Available method IDs for the Vulnerability GetStarted modal
 */
export type VulnerabilityGetStartedMethodId =
  | 'seeds'
  | 'integrations'
  | 'import';

/**
 * Vulnerability-specific get started methods
 *
 * These methods guide users through discovering vulnerabilities:
 * - Seeds: Scan defined targets to discover vulnerabilities
 * - Integrations: Connect external vulnerability scanners
 * - Import: Bulk upload from vulnerability scanning tools
 */
export const VULNERABILITY_GET_STARTED_METHODS: GetStartedMethod<VulnerabilityGetStartedMethodId>[] =
  [
    {
      id: 'seeds',
      title: 'Auto Discover',
      description:
        "Locate vulnerabilities by adding just a few 'seed' domains or cider ranges and chariot will take care of the rest",
      icon: SeedsIcon,
      buttonLabel: 'Add Seeds',
      buttonStyle: 'primary',
    },
    {
      id: 'integrations',
      title: 'Configure Integrations',
      description:
        'Integrate vulnerability scanners like Nessus, Rapid7, Qualys, Burp, or Invicti',
      icon: IntegrationsIcon,
      buttonLabel: 'Add Integrations',
      buttonStyle: 'primary',
    },
    {
      id: 'import',
      title: 'Import Vulnerabilities',
      description: 'Upload from Qualys, Nessus, InsightVM, or NSA CSaaS',
      icon: ArrowUpTrayIcon,
      buttonLabel: 'Import Vulnerabilities',
      buttonStyle: 'primary',
    },
  ];
